import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './texteditor.html';
import TextEditorComponent from './texteditor.component';

const textEditorConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('texteditor', {
		title:                         'Text Editor',
		template,
		children:   false,
		selectable: true,
		settings:                      new TextEditorComponent(),
		icon:                          'fa fa-align-left',
		noDndOverlay:                  true,
		confirmRemove:                 true,
		views:                         [
			{
				name:     'Display',
				template: 'kform/components/textfield/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/textfield/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller:    /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.changeValue = () => {
				if ($scope.component.event && typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(textEditorConfig);
